import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcEnter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.75 5.188A2.25 2.25 0 0 1 10 2.938h9.875a2.25 2.25 0 0 1 2.25 2.25v13.084q0 .09-.02.173a2.25 2.25 0 0 1-1.5 1.828l-4.938 1.693a2.25 2.25 0 0 1-2.9-1.529H10a2.25 2.25 0 0 1-2.25-2.25v-1.03a.75.75 0 0 1 1.5 0v1.03c0 .415.336.75.75.75h2.688V7.48c0-.962.61-1.817 1.52-2.129l2.666-.913H10a.75.75 0 0 0-.75.75v1.405a.75.75 0 1 1-1.5 0zm12.875.6a.75.75 0 0 0-.993-.71L14.694 6.77a.75.75 0 0 0-.507.71v12.358a.75.75 0 0 0 .994.71l4.937-1.693a.75.75 0 0 0 .507-.71z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.438 12.44h3.78l-1.907 1.908a.74.74 0 0 0-.225.52.73.73 0 0 0 .21.534.75.75 0 0 0 .539.236.71.71 0 0 0 .53-.22l3.094-3.095a.87.87 0 0 0 .27-.633.87.87 0 0 0-.27-.632L5.364 7.964a.72.72 0 0 0-.542-.225.72.72 0 0 0-.527.24.74.74 0 0 0-.212.532q.005.299.212.506l1.923 1.923h-3.78a.73.73 0 0 0-.535.216.73.73 0 0 0-.216.534q0 .32.216.535a.73.73 0 0 0 .535.215"
  }));
}
var IcEnter = createNolIcon(/*#__PURE__*/forwardRef(SvgIcEnter));

export { IcEnter as I };
